/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown> }} Portal_Remind_Email_SubjectInputs */

const en_portal_remind_email_subject = /** @type {(inputs: Portal_Remind_Email_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your day: ${i?.day}`)
};

const pl_portal_remind_email_subject = /** @type {(inputs: Portal_Remind_Email_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Twój dzień: ${i?.day}`)
};

/**
* | output |
* | --- |
* | "Your day: {day}" |
*
* @param {Portal_Remind_Email_SubjectInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_remind_email_subject = /** @type {((inputs: Portal_Remind_Email_SubjectInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Remind_Email_SubjectInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_remind_email_subject(inputs)
	return en_portal_remind_email_subject(inputs)
});